<footer>
    <ng-content></ng-content>
</footer>